export const getBoxPositionOnWindowCenter = (width, height) => ({
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
});

export const getBoxPositionOnScreenCenter = (width, height) => ({
    top: (window.screen.height - height) / 2,
    left: (window.screen.width - width) / 2,
});
